export default {
  sbRateConfig: {
    column: {
      orderNo: '框架协议编号',
      interestType: '利率类型',
      interestUnit: '利率计价单位',
      settleNo: '结算批次编号',
      occupationPeriod: '利率周期',
      interestEffectiveStartDays: '利率期限起始天数',
      interestEffectiveEndDays: '利率期限到期天数',
      interestRate: '利率(%)',
      remark: '备注',
    },
    placeholder: {
      auto: '自动生成',
      interestEffectiveStartDays: '请输入利率期限起始天数',
      interestEffectiveEndDays: '请输入利率期限到期天数',
      interestRate: '请输入利率',
    },
    collapseTitle: {
      basicTitle: '基本信息',
      detailTitle: '利率明细信息',
    },
  },
};
